export default __webpack_public_path__ + "static/media/465.01b382f8.gif";